import React, { useEffect, useState, useRef } from 'react';
import { Send, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
interface MessageInputProps {
  onSend: (message: string) => void;
  disabled?: boolean;
  placeholder?: string;
}
export function MessageInput({
  onSend,
  disabled,
  placeholder
}: MessageInputProps) {
  const [input, setInput] = useState('');
  const handleSend = () => {
    if (!input.trim() || disabled) return;
    onSend(input.trim());
    setInput('');
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };
  return <div className="p-4 border-t border-border/40 bg-background sticky bottom-0" data-id="element-86">
      <div className="max-w-3xl mx-auto flex gap-2 items-end" data-id="element-87">
        <Input value={input} onChange={e => setInput(e.target.value)} onKeyDown={handleKeyDown} placeholder={placeholder || 'Type a message...'} disabled={disabled} className="flex-1 min-h-[44px]" data-id="element-88" />
        <Button onClick={handleSend} disabled={!input.trim() || disabled} size="icon" className="rounded-full h-11 w-11 flex-shrink-0" data-id="element-89">
          {disabled ? <Loader2 size={18} className="animate-spin" data-id="element-90" /> : <Send size={18} data-id="element-91" />}
        </Button>
      </div>
      <p className="text-[10px] text-muted-foreground mt-2 text-center opacity-70" data-id="element-92">
        AI can make mistakes. Check important info.
      </p>
    </div>;
}